import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import React, { useState } from "react";
import SwitchToggle from "../../../components/SwitchToggle";
import SearchBar from "../../../components/SearchBar";
import AddAttributes from "../../../Modals/addattributes";
import AddVariant from "../../../Modals/addvariant";

const ManageAttributes = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [rows] = useState([
    {
      id: 1,
      name: "Red",
      count: 1,
      type: "Color",
      status: true,
    },
    {
      id: 2,
      name: "white",
      count: 1,
      type: "Color",
      status: true,
    },
  ]);
  const [expandedAttributeId, setExpandedAttributeId] = useState<number | null>(null);

  const [openModal, setOpenModal] = useState(false);
  const [openVariantModal, setOpenVariantModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleCloseVariantModal = () => {
    setOpenVariantModal(false);
  };

  // Mock data for variants
  const variants = [
    { id: 1, name: "M", status: true },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Manage Attributes</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Attributes
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Attributes..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add Attribute
            </Button>
          </div>
        </div>
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                <TableCell sx={{ fontWeight: 600 }}>#</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Variant</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Attribute Type</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Inactivated/Activated</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <React.Fragment key={row.id}>
                  <TableRow hover>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>
                      <Button
                        className="btn btn_primary sm"
                        onClick={() => setExpandedAttributeId(expandedAttributeId === row.id ? null : row.id)}
                      >
                        {expandedAttributeId === row.id ? "Hide" : "View"}
                      </Button>
                    </TableCell>
                    <TableCell>{row.type}</TableCell>
                    <TableCell>
                      <SwitchToggle defaultChecked={row.status} />
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton onClick={() => setOpenModal(true)}>
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="Delete" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>

                  {/* Expanded Row for Variants */}
                  <TableRow>
                    <TableCell colSpan={6} style={{ padding: 0, borderBottom: 'none' }}>
                      <Collapse in={expandedAttributeId === row.id} timeout="auto" unmountOnExit>
                        <Box sx={{ padding: '20px', backgroundColor: '#fcfcfc' }}>
                          <div className="main_title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                            <h2 style={{ fontSize: '1.1rem', fontWeight: 600 }}>Attribute Value</h2>
                            <div style={{ display: 'flex', gap: '10px' }}>
                              <Button
                                className="btn btn_primary sm"
                                onClick={() => setOpenVariantModal(true)}
                              >
                                + Add Variant
                              </Button>
                            </div>
                          </div>

                          <TableContainer className="table_container" sx={{ boxShadow: 'none', border: '1px solid #eee' }}>
                            <Table size="small">
                              <TableHead>
                                <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                                  <TableCell sx={{ fontWeight: 600 }}>#</TableCell>
                                  <TableCell sx={{ fontWeight: 600 }}>Variant Name</TableCell>
                                  <TableCell sx={{ fontWeight: 600 }}>Inactivated/Activated</TableCell>
                                  <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {variants.map((variant, vIndex) => (
                                  <TableRow key={variant.id}>
                                    <TableCell>{vIndex + 1}</TableCell>
                                    <TableCell>{variant.name}</TableCell>
                                    <TableCell>
                                      <SwitchToggle defaultChecked={variant.status} />
                                    </TableCell>
                                    <TableCell>
                                      <div className="table_actions v2">
                                        <IconButton onClick={() => setOpenVariantModal(true)}>
                                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                        </IconButton>
                                        <IconButton>
                                          <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                        </IconButton>
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>

                          </TableContainer>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>


      </div>
      <AddAttributes
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
      <AddVariant
        open={openVariantModal}
        onClose={handleCloseVariantModal}
        setOpen={setOpenVariantModal}
      />
    </>
  );
};

export default ManageAttributes;
